import { render, staticRenderFns } from "./AssociatedPersonsInput.vue?vue&type=template&id=17ca9b7e&scoped=true&"
import script from "./AssociatedPersonsInput.vue?vue&type=script&lang=ts&"
export * from "./AssociatedPersonsInput.vue?vue&type=script&lang=ts&"
import style0 from "./AssociatedPersonsInput.vue?vue&type=style&index=0&id=17ca9b7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17ca9b7e",
  null
  
)

export default component.exports